// components/GuildLogo.js - 길드 로고 렌더링 컴포넌트
import React from 'react';

// 기본 길드 로고 이미지 옵션 (다른 컴포넌트와 동일)
const DEFAULT_GUILD_LOGOS = [
  { id: 'castle', emoji: '🏰', name: '성', color: '#667eea' },
  { id: 'shield', emoji: '🛡️', name: '방패', color: '#f093fb' },
  { id: 'crossed_swords', emoji: '⚔️', name: '검', color: '#ff6b6b' },
  { id: 'crown', emoji: '👑', name: '왕관', color: '#fbbf24' },
  { id: 'fire', emoji: '🔥', name: '불꽃', color: '#f59e0b' },
  { id: 'lightning', emoji: '⚡', name: '번개', color: '#8b5cf6' },
  { id: 'star', emoji: '⭐', name: '별', color: '#10b981' },
  { id: 'gem', emoji: '💎', name: '다이아몬드', color: '#06b6d4' },
  { id: 'trophy', emoji: '🏆', name: '트로피', color: '#f59e0b' },
  { id: 'rocket', emoji: '🚀', name: '로켓', color: '#3b82f6' },
  { id: 'phoenix', emoji: '🔮', name: '수정구', color: '#8b5cf6' },
  { id: 'dragon', emoji: '🐉', name: '드래곤', color: '#ef4444' }
];

function GuildLogo({ 
  logoUrl, 
  guildName, 
  size = 80, 
  showBorder = true, 
  borderColor = 'rgba(255,255,255,0.3)',
  className = '',
  style = {}
}) {
  // 기본 로고인지 확인
  const isDefaultLogo = logoUrl && logoUrl.startsWith('default_logo_');
  
  // 기본 로고 정보 가져오기
  const getDefaultLogoInfo = () => {
    if (!isDefaultLogo) return null;
    
    const logoId = logoUrl.replace('default_logo_', '');
    return DEFAULT_GUILD_LOGOS.find(logo => logo.id === logoId);
  };

  const defaultLogoInfo = getDefaultLogoInfo();

  // 스타일 계산
  const containerStyle = {
    width: size,
    height: size,
    borderRadius: size > 60 ? 16 : 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    border: showBorder ? `2px solid ${borderColor}` : 'none',
    ...style
  };

  // 기본 로고 렌더링
  if (isDefaultLogo && defaultLogoInfo) {
    return (
      <div 
        className={className}
        style={{
          ...containerStyle,
          background: `linear-gradient(135deg, ${defaultLogoInfo.color}20, ${defaultLogoInfo.color}10)`,
          color: defaultLogoInfo.color,
          fontSize: size * 0.45,
          fontWeight: 'bold',
          textShadow: `0 2px 8px ${defaultLogoInfo.color}40`
        }}
        title={`${guildName} - ${defaultLogoInfo.name} 로고`}
      >
        {defaultLogoInfo.emoji}
      </div>
    );
  }

  // 업로드된 이미지 렌더링
  if (logoUrl && !isDefaultLogo) {
    return (
      <div 
        className={className}
        style={containerStyle}
        title={`${guildName} 로고`}
      >
        <img 
          src={logoUrl} 
          alt={`${guildName} 로고`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onError={(e) => {
            // 이미지 로드 실패시 기본 아이콘으로 대체
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<span style="font-size: ' + (size * 0.4) + 'px; color: #9ca3af;">🏰</span>';
          }}
        />
      </div>
    );
  }

  // 로고가 없는 경우 기본 아이콘
  return (
    <div 
      className={className}
      style={{
        ...containerStyle,
        background: '#f3f4f6',
        color: '#9ca3af',
        fontSize: size * 0.4
      }}
      title={`${guildName} - 기본 로고`}
    >
      🏰
    </div>
  );
}

export default GuildLogo;